// extracted by mini-css-extract-plugin
export default {"likeIcon":"_89567d67","showHeartBeat":"_b9aa463c","heart-beat":"_4f436c32","heartBeat":"_4f436c32","isFilled":"_2c3f4c13","dark":"_d7ae057b","light":"_a14a50d9"};